module.exports = __webpack_public_path__ + "img/play_circle_outline.77eb5e57.svg";